// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageComponent_container__3WQUi","imageWrapper":"ImageComponent_imageWrapper__2YjLr"};